var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.998 8.286c0.001 0.001 0.002 0.002 0.002 0.002v15.424c-0.001 0.001-0.002 0.002-0.002 0.002h-17.995c-0.001-0.001-0.002-0.002-0.002-0.002v-15.424c0.001-0.001 0.002-0.002 0.002-0.002h17.995zM25 7h-18c-0.707 0-1.286 0.579-1.286 1.286v15.429c0 0.707 0.579 1.286 1.286 1.286h18c0.707 0 1.286-0.579 1.286-1.286v-15.429c0-0.707-0.579-1.286-1.286-1.286v0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.429 11.5c0 1.065-0.863 1.929-1.929 1.929s-1.929-0.863-1.929-1.929 0.863-1.929 1.929-1.929 1.929 0.863 1.929 1.929z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.714 22.429h-15.429v-2.571l4.5-7.714 5.143 6.429h1.286l4.5-3.857z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideImages);
export default __webpack_public_path__ + "static/media/hide-images.a6e6f214e4c55840ff6c63400bdd9c4b.svg";
export { ForwardRef as ReactComponent };